/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface FAQRequest
 */
export interface FAQRequest {
  /**
   *
   * @type {string}
   * @memberof FAQRequest
   */
  answer: string
  /**
   *
   * @type {string}
   * @memberof FAQRequest
   */
  question: string
  /**
   * * `category` - Category
   * * `object` - Object
   * * `service` - Service
   * * `static_page` - Static Page
   * @type {string}
   * @memberof FAQRequest
   */
  type?: FAQRequestTypeEnum
  /**
   *
   * @type {number}
   * @memberof FAQRequest
   */
  entityId?: number | null
  /**
   *
   * @type {number}
   * @memberof FAQRequest
   */
  score?: number | null
  /**
   *
   * @type {number}
   * @memberof FAQRequest
   */
  regionId?: number
  /**
   * * `1` - Template 1
   * * `2` - Template 2
   * * `3` - Template 3
   * @type {number}
   * @memberof FAQRequest
   */
  serviceTemplateType?: FAQRequestServiceTemplateTypeEnum
}

/**
 * @export
 */
export const FAQRequestTypeEnum = {
  Category: 'category',
  Object: 'object',
  Service: 'service',
  StaticPage: 'static_page',
} as const
export type FAQRequestTypeEnum = (typeof FAQRequestTypeEnum)[keyof typeof FAQRequestTypeEnum]

/**
 * @export
 */
export const FAQRequestServiceTemplateTypeEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
} as const
export type FAQRequestServiceTemplateTypeEnum =
  (typeof FAQRequestServiceTemplateTypeEnum)[keyof typeof FAQRequestServiceTemplateTypeEnum]

/**
 * Check if a given object implements the FAQRequest interface.
 */
export function instanceOfFAQRequest(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'answer' in value
  isInstance = isInstance && 'question' in value

  return isInstance
}

export function FAQRequestFromJSON(json: any): FAQRequest {
  return FAQRequestFromJSONTyped(json, false)
}

export function FAQRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FAQRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    answer: json['answer'],
    question: json['question'],
    type: !exists(json, 'type') ? undefined : json['type'],
    entityId: !exists(json, 'entityId') ? undefined : json['entityId'],
    score: !exists(json, 'score') ? undefined : json['score'],
    regionId: !exists(json, 'regionId') ? undefined : json['regionId'],
    serviceTemplateType: !exists(json, 'serviceTemplateType')
      ? undefined
      : json['serviceTemplateType'],
  }
}

export function FAQRequestToJSON(value?: FAQRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    answer: value.answer,
    question: value.question,
    type: value.type,
    entityId: value.entityId,
    score: value.score,
    regionId: value.regionId,
    serviceTemplateType: value.serviceTemplateType,
  }
}
